import { useColorMode } from "@chakra-ui/react";
import Color from "color";
import { useEffect } from "react";
import { useBrandingContext } from "./branding/useBrandingContext";

export const ColorModeConfiguration = () => {
  const branding = useBrandingContext();
  const { setColorMode } = useColorMode();

  useEffect(() => {
    const currentMode = Color(branding.background || undefined).isDark()
      ? "dark"
      : "light";
    if (branding.background) setColorMode(currentMode);
  }, [setColorMode, branding]);

  return null;
};
